import { useEffect, useMemo, useState } from "react";
import {
  getLmsDashboardCopy,
  getJourneySteps,
  progressCards,
} from "../utils/lmsDashboardContent";
import { getStudents } from "../students/controllers/studentController";
import LmsEmptyState from "./LmsEmptyState";

const LmsDashboardHome = ({ role }) => {
  const copy = getLmsDashboardCopy(role);
  const journeySteps = getJourneySteps(role);
  const [hasStudents, setHasStudents] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadStudents = async () => {
      try {
        const response = await getStudents();
        const count = Array.isArray(response?.data?.students) ? response.data.students.length : 0;
        if (isMounted) {
          setHasStudents(count > 0);
        }
      } catch {
        if (isMounted) {
          setHasStudents(false);
        }
      }
    };

    loadStudents();

    return () => {
      isMounted = false;
    };
  }, []);

  const singularLabel = useMemo(() => copy.studentLabel.slice(0, -1), [copy.studentLabel]);
  const actionLabel = hasStudents ? `Create ${singularLabel}` : `Create first ${singularLabel}`;

  return (
    <div className="lms-dashboard-home">
      <section className="lms-hero">
        <p className="eyebrow">{copy.audienceLabel}</p>
        <h1>{copy.greeting}</h1>
        <p>{copy.intro}</p>
      </section>

      <section className="lms-card-grid" aria-label="Reading progress overview">
        {progressCards.map((card) => (
          <article className="lms-progress-card" key={card.label}>
            <span>{card.label}</span>
            <strong>{card.value}</strong>
            <p>{card.hint}</p>
          </article>
        ))}
      </section>

      <section className="lms-journey" aria-label="Reading journey">
        <h2>The reading growth journey</h2>
        <div className="lms-journey-track">
          {journeySteps.map((step, index) => (
            <article key={step}>
              <span>{index + 1}</span>
              <p>{step}</p>
            </article>
          ))}
        </div>
      </section>

      <LmsEmptyState
        title={copy.emptyTitle}
        body={copy.emptyBody}
        actionLabel={actionLabel}
        actionTo="/dashboard/students/new"
      />
    </div>
  );
};

export default LmsDashboardHome;
